import type { Translations } from '../../types'

const commandMessages: Translations = {
  "command.group.navigation": "Navigazione",
  "command.group.profile": "Profilo",
  "command.group.account": "Account",
  "command.nav.dashboard": "Dashboard",
  "command.nav.dashboard.subtitle": "Stato generale e metriche veloci",
  "command.nav.supportRequests": "Richieste assistenza",
  "command.nav.supportRequests.subtitle": "Gestisci richieste dei clienti",
  "command.nav.supportInbox": "Ticket assistenza",
  "command.nav.supportInbox.subtitle": "Gestisci e apri richieste di assistenza",
  "command.nav.slider": "Slider Hero",
  "command.nav.slider.subtitle": "Gestisci le slide della homepage",
  "command.nav.pages": "Pagine",
  "command.nav.pages.subtitle": "Crea o modifica le pagine del sito",
  "command.nav.siteSettings": "Site settings",
  "command.nav.siteSettings.subtitle": "Branding, footer e link legali",
  "command.nav.site.branding": "Brand e homepage",
  "command.nav.site.branding.subtitle": "Nome sito, logo, favicon e homepage",
  "command.nav.themes": "Theme manager",
  "command.nav.themes.subtitle": "Palette, tipografia, raggi e attivazione",
  "command.nav.site.footer": "Footer",
  "command.nav.site.footer.subtitle": "Nota footer e link pubblici",
  "command.nav.site.legal": "Privacy e policy",
  "command.nav.site.legal.subtitle": "Privacy, cookie policy e termini",
  "command.nav.site.contact": "Contatti e social",
  "command.nav.site.contact.subtitle": "Email/telefono pubblici e link social",
  "command.nav.site.emailSettings": "Configurazione email",
  "command.nav.site.emailSettings.subtitle": "Configura SMTP, invio e diagnostica email",
  "command.nav.site.emailTemplates": "Template email",
  "command.nav.site.emailTemplates.subtitle": "Gestisci contenuti, placeholder e anteprime dei template",
  "command.nav.site.emailLogs": "Log email",
  "command.nav.site.emailLogs.subtitle": "Controlla test SMTP e storico invii email",
  "command.nav.site.payments": "Pagamenti",
  "command.nav.site.payments.subtitle": "Abilitazione provider, default e configurazione pagamenti",
  "command.nav.systemStatus": "Stato sistemi",
  "command.nav.systemStatus.subtitle": "Health check di tutti i servizi",
  "command.nav.updates": "Updates",
  "command.nav.updates.subtitle": "Stato release e operazioni di rollback/deploy",
  "command.nav.featureFlags": "Feature Flags",
  "command.nav.featureFlags.subtitle": "Gestisci rollout e attivazioni progressive",
  "command.nav.auditLogs": "Audit log",
  "command.nav.auditLogs.subtitle": "Cronologia eventi sensibili e operazioni admin",
  "command.nav.auditTrail": "Audit trail globale",
  "command.nav.auditTrail.subtitle": "Timeline eventi auth/CMS/catalogo/ordini + Stripe webhook",
  "command.nav.builder": "Compositore contenuti",
  "command.nav.builder.subtitle": "Apri il Compositore contenuti",
  "command.nav.homepageBuilder.subtitle": "Modifica la pagina nel Compositore contenuti",
  "command.nav.menu": "Menu homepage",
  "command.nav.menu.subtitle": "Ordina e aggiorna le voci del menu",
  "command.nav.shopProducts": "Prodotti",
  "command.nav.shopProducts.subtitle": "Gestisci catalogo, prezzi e quantità",
  "command.nav.shopCategories": "Categorie",
  "command.nav.shopCategories.subtitle": "Gestisci categorie e sottocategorie",
  "command.nav.shopOrders": "Ordini",
  "command.nav.shopOrders.subtitle": "Filtra ordini per cliente e stato",
  "command.nav.shopCustomers": "Clienti",
  "command.nav.shopCustomers.subtitle": "Consulta anagrafica clienti e storico ordini",
  "command.nav.shopMigrations": "Migrazioni shop",
  "command.nav.shopMigrations.subtitle": "Import/export catalogo in ZIP",
  "command.nav.shopProductTypes": "Modelli prodotto",
  "command.nav.shopProductTypes.subtitle": "Crea modelli prodotto e gestisci i package",
  "command.nav.plugins": "Plugin",
  "command.nav.plugins.subtitle": "Gestisci estensioni plugin",
  "command.nav.languages": "Lingue",
  "command.nav.languages.subtitle": "Gestisci le lingue disponibili",
  "command.profile.contact": "Profilo account",
  "command.profile.contact.subtitle": "Panoramica profilo, dati personali e avatar",
  "command.profile.preferences": "Preferenze",
  "command.profile.preferences.subtitle": "Lingua interfaccia e comunicazioni",
  "command.profile.smtp": "Configurazione email (SMTP)",
  "command.profile.smtp.subtitle": "Gestisci SMTP runtime e diagnostica invii",
  "command.profile.security": "Sicurezza account",
  "command.profile.security.subtitle": "Aggiorna la password e i controlli di accesso",
  "command.profile.sessions": "Sessioni e dispositivi",
  "command.profile.sessions.subtitle": "Consulta e gestisci i device collegati",
  "command.profile.team": "Team e ruoli",
  "command.profile.team.subtitle": "Gestisci gli utenti e i ruoli admin",
  "command.profile.danger": "Privacy",
  "command.profile.danger.subtitle": "Consensi, export dati e gestione account",
  "command.account.logout": "Logout",
  "command.account.logout.subtitle": "Termina la sessione corrente",
  "command.group.default": "Comandi rapidi",
  "command.palette.label": "Command palette",
  "command.palette.placeholder": "Cerca comandi, sezioni, scorciatoie...",
  "command.palette.searchingCustomers": "Ricerca clienti in corso...",
  "command.palette.empty": "Nessun comando disponibile"
}

export default commandMessages
